module.exports = __webpack_public_path__ + "static/fonts/Fontfabric - NexaHeavy.b868d275.otf";